import React from 'react';
import './App.css';
import Login from './pages/Login';
import ToDo from './pages/ToDoList'
import { Route, Routes } from 'react-router-dom';

function App() {
  return (
    <div className="App">
       <Routes>
        <Route  path="/todo" element={ <ToDo/> } />
        <Route  path ="/" element= {<Login/>}/>
       <Route  path ="*" element= {<Login/>}/>
        </Routes>

    </div>
  );
}

export default App;
